import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { message } from 'antd';
import { useProjectContext } from './ProjectContext';
import { getConfig } from '../config';

const { API_BASE_URL } = getConfig();
const AUTH_TOKEN = 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU';

interface BadgeCounts {
    [key: string]: number | null;
}

interface BadgeContextProps {
    badgeCounts: BadgeCounts;
    refreshBadgeCounts: () => void;
}

const BadgeContext = createContext<BadgeContextProps | undefined>(undefined);

export const BadgeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { selectedProject, selectedManagerNo } = useProjectContext();
    const [badgeCounts, setBadgeCounts] = useState<BadgeCounts>({});

    const fetchBadgeCounts = async () => {
        if (!selectedProject) return;
        try {
            const response = await axios.get(
                `${API_BASE_URL}/getNetworkPlanBadgeCount?auth=${AUTH_TOKEN}&projectNo=${selectedProject}&managerNo=${selectedManagerNo}`
            );
            setBadgeCounts(response.data);
        } catch (error) {
            message.error('Fehler beim Abrufen der Badge-Zähler.');
            setBadgeCounts({});
        }
    };

    useEffect(() => {
        fetchBadgeCounts();
    }, [selectedProject]);

    return (
        <BadgeContext.Provider value={{ badgeCounts, refreshBadgeCounts: fetchBadgeCounts }}>
            {children}
        </BadgeContext.Provider>
    );
};

export const useBadgeContext = () => {
    const context = useContext(BadgeContext);
    if (!context) {
        throw new Error('useBadgeContext must be used within a BadgeProvider');
    }
    return context;
};
